export const USER_ACCOUNT_CLOSED = -1;
export const USER_CREATED = 0;
export const USER_MAIL_VERIFIED = 1;
export const USER_PHONE_VERIFIED = 2;
export const USER_ADDRESS_VERIFIED = 3;
export const USER_FULLY_VERIFIED = 4;
